<template>
  <div class="container" :class="{ 'is-pre-match': isPreMatch }">
    <template v-if="isPreMatch">
      <div class="container__abbreviation">
        T.E.
      </div>
      <div class="container__minutes" :style="styleMinutes">
        {{ time }}
      </div>
    </template>
    <template v-else>
      <div class="container__abbreviation" :style="styleAbbreviation">
        {{ isActive ? 'T.E.' : 'T.I.' }}
      </div>
      <div class="container__minutes" :style="styleMinutes">
        {{ time }}
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'ActiveAndInactiveTimeCalendar',
  props: {
    isPreMatch: {
      type: Boolean,
      default: false,
    },
    isLive: {
      type: Boolean,
      default: false,
    },
    isActive: {
      type: Boolean,
      default: true,
    },
    time: {
      type: String,
      default: '00:00',
    },
  },
  computed: {
    styleAbbreviation() {
      return this.isActive
        ? {
            'background-color': this.isLive ? '#cbfb48' : '#132839',
            color: this.isLive ? '#132839' : 'white',
            'font-family': this.isLive ? 'Avenir-Bold' : 'Avenir-Demi',
          }
        : {
            'background-color': this.isLive ? '#007195' : '#dfe7ea',
            color: this.isLive ? 'white' : '#132839',
            'font-family': 'Avenir-Bold',
          };
    },
    styleMinutes() {
      return this.isActive
        ? {
            border: `solid 1px ${this.isLive ? '#cbfb48' : '#132839'}`,
            'font-family': 'Avenir-Bold',
          }
        : {
            border: `solid 1px ${this.isLive ? '#007195' : '#dfe7ea'}`,
            'font-family': 'Avenir-Demi',
          };
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  width: 100%;
  display: grid;
  grid-template-columns: 40% 60%;

  &.is-pre-match {
    display: flex;
    flex-direction: column;

    & .container__abbreviation {
      padding: 0.5em 0 0.4em;
      border-radius: 3px;
      background-color: #dfe7ea;
      margin-bottom: 1em;
      font-family: Avenir-Demi, sans-serif;
      font-size: 10px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 0.89;
      letter-spacing: normal;
      text-align: center;
      color: #132839;
    }

    & > div.container__minutes {
      border-radius: 0 !important;
      border: solid 1px white !important;
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 0.64;
      letter-spacing: -0.28px;
      text-align: center;
      color: #132839;
    }
  }

  &__abbreviation {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
  }

  &__minutes {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
    color: #132839;
  }

  &__pre-match {
  }
}
</style>
